import React, { Component } from "react";
import { Switch, DatePicker } from "antd";
import "./UploadFolderStep3.css";
import TagsUpload from "./TagsUpload";
import UsersEmails from "./UsersEmails";
import { updateMetadata } from "../../../actions/UploadFolderAction";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { sendNotification } from "../../../utils";
import { fetchUsersToMention } from "../../../api/GroupApi";

class UploadFolderStep3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      showSpinnerEmail: true
    };
  }
  componentDidMount() {
    this.fetchUsers();
    const { usageRights, dateFrom, dateTo } = this.props.uploadFolder;
    if (usageRights) {
      if (dateFrom) {
        this.props.updateMetadata({
          dateFrom: null,
          dateFromFormatted: null
        });
      }
      if (dateTo) {
        this.props.updateMetadata({
          dateTo: null,
          dateToFormatted: null
        });
      }
    }
  }
  handleTags = objectTag => {
    this.props.updateMetadata({
      tags: objectTag.tags
    });
  };

  onChangeDateFrom = (date, dateString) => {
    if (date) {
      const formatedDate = date.format("YYYY/MM/DD");
      this.props.updateMetadata({
        dateFrom: date,
        dateFromFormatted: formatedDate
      });
    } else {
      this.props.updateMetadata({
        dateFrom: null,
        dateFromFormatted: null
      });
    }
  };
  onChangeDateTo = (date, dateString) => {
    if (date) {
      const { intl, uploadFolder } = this.props;
      const { dateFrom } = uploadFolder;
      if (date.isBefore(dateFrom)) {
        sendNotification(
          "info",
          intl,
          intl.formatMessage({ id: "upload-folder-s3-date-incorrect" })
        );
        return;
      }
      const formatedDate = date.format("YYYY/MM/DD");
      this.props.updateMetadata({
        dateTo: date,
        dateToFormatted: formatedDate
      });
    } else {
      this.props.updateMetadata({
        dateTo: null,
        dateToFormatted: null
      });
    }
  };
  addUserEmail = emails => {
    this.props.updateMetadata({
      usersEmails: emails
    });
  };

  removeUserEmail = email => {
    const { usersEmails } = this.props.uploadFolder;
    if (email) {
      const newList = usersEmails.filter(e => e !== email);
      this.props.updateMetadata({
        usersEmails: newList
      });
    } else {
      usersEmails.pop();
      this.props.updateMetadata({
        usersEmails: usersEmails
      });
    }
  };
  handleOnChangeDescription = e => {
    this.props.updateMetadata({
      tagsProtocol: e.target.value
    });
  };

  fetchUsers = () => {
    this.setState({ showSpinnerEmail: true });
    const { uploadFolder, workclient } = this.props;
    fetchUsersToMention(workclient, uploadFolder.folderselect)
      .then(res => {
        const { adminUsers, operatorUsers } = res.data;
        const usersMentions = [...adminUsers, ...operatorUsers];
        const usersMentionsSorted = usersMentions.sort(
          (firstUser, secondUser) => {
            if (firstUser.name.toLowerCase() < secondUser.name.toLowerCase())
              return -1;
            if (firstUser.name.toLowerCase() === secondUser.name.toLowerCase())
              return 0;
            return 1;
          }
        );
        this.setState({
          users: usersMentionsSorted,
          showSpinnerEmail: false
        });
      })
      .catch(err => {
        this.setState({
          errorFetchingUsers: err,
          showSpinnerEmail: false
        });
      });
  };

  render() {
    const {
      usageRights,
      usersEmails,
      tagsProtocol,
      dateFrom,
      dateTo
    } = this.props.uploadFolder;

    const { intl } = this.props;
    const { users, showSpinnerEmail } = this.state;
    
    return (
      <div
        style={{
          width: "100%",
          height: 450,
          paddingLeft: "5%",
          paddingRight: "5%",
          paddingTop: "1%",
          paddingBottom: "1%",
          overflowY: "auto"
        }}
      >
        <div className="containerUploadFolderStep3">
          <div className="section1">
            <p className="tag_title">
              {intl.formatMessage({ id: "tags_upload_add_tags" })}
            </p>
            <TagsUpload handleTags={this.handleTags} inputEnabled />
            {tagsProtocol && tagsProtocol.length > 0 && (
              <div>
                <p className="tag_title">
                  {intl.formatMessage({ id: "tags_protocol" })}
                </p>
                <div
                  className="tag_protocol_container"
                  dangerouslySetInnerHTML={{ __html: tagsProtocol }}
                />
                {/* <TextArea
                  rows={5}
                  className="tag_protocol_container"
                  placeholder={intl.formatMessage({
                    id: "new_folder_description"
                  })}
                  name="longDescription"
                  maxLength={75}
                  value={tagsProtocol}
                  onChange={this.handleOnChangeDescription}
                  disabled
                /> */}
              </div>
            )}
          </div>
          <div className="section2">
            <p className="tag_title">
              {intl.formatMessage({ id: "copyright" })}
            </p>
            <div className="tag_row">
              <Switch
                onChange={e => {
                  this.props.updateMetadata({
                    usageRights: !usageRights,
                    dateFrom: null,
                    dateFromFormatted: null,
                    dateTo: null,
                    dateToFormatted: null
                  });
                }}
                style={{ marginRight: 10 }}
                checked={usageRights}
              />
              <p>
                {intl.formatMessage({ id: "upload-folder-s3-tg_description" })}
              </p>
            </div>
            {usageRights && (
              <div className="dates_row">
                <div className="tag_col">
                  <p className="date_selector_title">
                    {intl.formatMessage({ id: "upload-folder-s4-date-from" })}
                  </p>
                  <DatePicker
                    onChange={this.onChangeDateFrom}
                    placeholder="Seleccione"
                    style={{ width: 150 }}
                    value={dateFrom}
                    className="custom_date_picker"
                    format="DD/MM/YYYY"
                  />
                </div>
                <div className="tag_col">
                  <p className="date_selector_title">
                    {intl.formatMessage({ id: "upload-folder-s4-date-to" })}
                  </p>
                  <DatePicker
                    onChange={this.onChangeDateTo}
                    placeholder="Seleccione"
                    style={{ width: 150 }}
                    value={dateTo}
                    className="custom_date_picker"
                    format="DD/MM/YYYY"
                  />
                </div>
              </div>
            )}
            {!usageRights && (
              <p className="step3_usage">
                {intl.formatMessage({ id: "upload-folder-s3-usage" })}
              </p>
            )}
            <p className="tag_title">
              {intl.formatMessage({ id: "upload-folder-s4-notify" })}
            </p>
            <UsersEmails
              usersEmails={usersEmails}
              usersEmailAutoComplete={users}
              onRemove={e => {
                this.removeUserEmail(e);
              }}
              onAdd={this.addUserEmail}
              inputEnabled
              showSpinnerEmail={showSpinnerEmail}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    uploadFolder: state.uploadFolder,
    workclient: state.client.data ? state.client.data._id : null
  };
};

const mapDispatchToProps = {
  updateMetadata
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderStep3))
);
